import {
  maxMobile,
  primaryColor,
  primaryFont, primaryHeadingColor, secondaryFont, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { Modal } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { IsMobile, valueToObject } from 'Utils/UtilityFunctions';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { useDispatch } from 'react-redux';
import GilroyWhiteSvg from '../assets/svgIcons/GilroyWhiteSvg';
import CrossCircle from '../assets/svgIcons/CrossCircle';

type Props = {
  showPopup: boolean,
  onClickCancel: () => void,
  onClickOk: () => void,
  okText: string,
  cancelText: string,
  popupText: string,
};

const UploadDocCancelModal = styled(Modal)`
.ant-modal-content {
  .ant-modal-close {
    .ant-modal-close-x {
      .cross-icon-x {
        svg {
          @media all and (max-width: ${maxMobile}) {
            width: 23px;
            height: 23px;
            margin: 16px 0 0 0;
          }
        }
      }
    }
  }
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 100px 0px !important;
    @media all and (max-width: ${maxMobile}) {
      padding: 30px 10px 0px !important;
    }
    .gilroy-white-svg {
      width: 95px;
      height: 100px;
      flex-shrink: 0;
      @media all and (max-width: ${maxMobile}) {
        width: 80px;
        height: 75px;
      }
    }
    .popup-text {
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      font-size: 22px;
      line-height: 28px;
      letter-spacing: -0.95px;
      text-align: center;
      color: ${primaryHeadingColor};
      @media all and (max-width: ${maxMobile}) {
        font-size: 18px;
        line-height: 22px;
      }
    }
  }
  .ant-modal-footer {
    padding: 8px 25px 16px !important;
  }
}
`;
const FooterWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
.buttons-div {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  .default-btn {
    border: 1.6px solid ${primaryColor};
    border-radius: 23px;
    text-align: center;
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wMBold};
    min-width: 108px;
    color: ${primaryColor};
    padding: 4px;
    cursor: pointer;
    @media all and (max-width: ${maxMobile}) {
      font-size: 12px;
      min-width: 85px;
    }
    &.primary {
      background-color: ${primaryColor};
      color: #fff;
      margin-left: 8px;
    }
  }
}
.underline-text-popup {
  font-family: ${primaryFont};
  font-size: 16px;
  line-height: 20px;
  font-weight: ${wMBold};
  text-align: center;
  color: ${primaryColor};
  margin-bottom: 32px;
  text-decoration: underline;
  @media all and (max-width: ${maxMobile}) {
    font-size: 12px;
    margin-bottom: 18px;
  }
  &.pointer{
    cursor: pointer;
  }
  &.sugestion-text {
    font-size: 12px;
    font-weight: ${wMedium};
    line-height: 16px;
    color: #999;
    margin-bottom: 0px;
    text-decoration: none;
    @media all and (max-width: ${maxMobile}) {
      font-size: 10px;
    }
   }
}
`;

const DocumentUploadCancelPopup = function DocumentUploadCancelPopup(props: Props) {
  const {
    showPopup,
    onClickCancel,
    onClickOk,
    okText, cancelText, popupText,
  } = props;
  const dispatch = useDispatch();
  const isMob = IsMobile();
  const host = window.location.href;
  const openNewTab = () => {
    window.open(process.env.REACT_APP_CALLBACK_URL);
    onClickCancel();
    dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_upload_cancel_openNewTab_clicked', 0, {
      host,
    })));
  };
  const FooterContent = (
    <FooterWrapper>
      <div className="buttons-div">
        <span
          tabIndex={0}
          role="button"
          className="default-btn"
          onClick={onClickCancel}
          onKeyDown={onClickCancel}
        >
          No
        </span>
        <span
          tabIndex={0}
          role="button"
          className="default-btn primary"
          onClick={onClickOk}
          onKeyDown={onClickOk}
        >
          Yes
        </span>
      </div>
      <span onClick={openNewTab} onKeyPress={openNewTab} tabIndex={0} role="button" className="underline-text-popup pointer">Use Sales App on new tab</span>
      <span className="underline-text-popup sugestion-text"> *  Continue using the app in a new browser tab while uploads proceed in the background.</span>
    </FooterWrapper>
  );

  return (
    <UploadDocCancelModal
      centered
      width={isMob ? 320 : 528}
      getContainer=""
      closeIcon={<div className="cross-icon-x"><CrossCircle onClick={onClickCancel} /></div>}
      visible={showPopup}
      onCancel={onClickCancel}
      onOk={onClickOk}
      okText={okText}
      cancelText={cancelText}
      footer={FooterContent}
    >
      <GilroyWhiteSvg />
      <h2 className="popup-text">{popupText}</h2>
    </UploadDocCancelModal>
  );
};
export default DocumentUploadCancelPopup;
